module.exports = __webpack_public_path__ + "static/media/alexander-400-400.40d0f2e7.webp";